import { useEffect, useState } from "react";
import "./App.css";
import SideNav from "./components/SideNav";
import AppContext from "./components/contexts/AppContext";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
 
import { ModalContext } from "./components/contexts/ModalContext";
import LinkMedia from "./components/PropertyList/LinkMedia";
import PhotoThumbnailModal from "./components/modal/PhotoThumbnailModal";
import PhotoThumbnail from "./components/Gallery/PhotoThumbnail";
import PhotoOnly from "./components/Gallery/PhotoOnly";
import GuestAccessGallery from "./components/Gallery/GuestAcessGallery";

function App() { 
  const [modalData, setModalData] = useState({currentGalleryName:null})
  const [isModalOpen, setModalOpen] = useState({ type: null, isOpen: false });

  // const [crossWordData, setCrossWordData] = useState({});

   const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [installable, setInstallable] = useState(false);

 useEffect(() => {
  if (localStorage.getItem("pwaInstalled") === "true") {
    return;
  }

  const handler = (e) => {
    const dismissed = localStorage.getItem(
      "pwaInstallDismissed"
    );

    if (
      dismissed &&
      Date.now() - Number(dismissed) <
        7 * 24 * 60 * 60 * 1000
    ) {
      return;
    }

    if (
      sessionStorage.getItem(
        "pwaPromptShown"
      ) === "true"
    ) {
      return;
    }

    e.preventDefault();

    sessionStorage.setItem(
      "pwaPromptShown",
      "true"
    );

    setDeferredPrompt(e);
    setInstallable(true);
  };

  const installedHandler = () => {
    localStorage.setItem(
      "pwaInstalled",
      "true"
    );

    setInstallable(false);
    setDeferredPrompt(null);
  };

  window.addEventListener(
    "beforeinstallprompt",
    handler
  );

  window.addEventListener(
    "appinstalled",
    installedHandler
  );

  return () => {
    window.removeEventListener(
      "beforeinstallprompt",
      handler
    );

    window.removeEventListener(
      "appinstalled",
      installedHandler
    );
  };
}, []);

  const handleMaybeLater = () => {
  localStorage.setItem(
    "pwaInstallDismissed",
    Date.now()
  );

  setInstallable(false);
};

  const handleInstallClick = async () => {
    console.log("dddddd ",deferredPrompt)
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    console.log("OUT COME ",outcome)
    if (outcome === "accepted") {
      console.log("App installed");
    } else {
      console.log("User dismissed install");
    }
    setDeferredPrompt(null);
    setInstallable(false);
  };

  return (
    <div className="App" style={{ userSelect: "none" }}>
     {installable && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.45)",
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "center",
      zIndex: 1000,
      backdropFilter: "blur(3px)",
      
    }}
  >
    <div
      style={{
        width: "100%",
        maxWidth: "500px",
        background: "#fff",
        borderTopLeftRadius: "24px",
        borderTopRightRadius: "24px",
        padding: "28px 22px",
        boxShadow: "0 -10px 30px rgba(0,0,0,0.18)",
        animation: "slideUp 0.25s ease-out",
      }}
    >
      {/* Top Drag Line */}
      <div
        style={{
          width: "50px",
          height: "5px",
          background: "#d1d5db",
          borderRadius: "999px",
          margin: "0 auto 22px",
        }}
      />

      {/* App Icon */}
      <div
        style={{
          width: "72px",
          height: "72px",
          borderRadius: "20px",
          overflow: "hidden",
          margin: "0 auto 18px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
        }}
      >
        <img
                  src={document.querySelector("link[rel*='icon']")?.href}
          alt="App Logo"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </div>

      {/* Heading */}
      <h2
        style={{
          textAlign: "center",
          fontSize: "24px",
          fontWeight: "700",
          marginBottom: "12px",
          color: "#111827",
        }}
      >
        Install Your Photo Gallery
      </h2>

      {/* Description */}
      <p
        style={{
          textAlign: "center",
          fontSize: "15px",
          lineHeight: "24px",
          color: "#6b7280",
          marginBottom: "26px",
        }}
      >
        Install this app to access your gallery anytime without saving links.
        It works like your personal app for quick and seamless access to all
        your memories.
      </p>

      {/* Buttons */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
        }}
      >
        <button
          onClick={handleInstallClick}
          style={{
            width: "100%",
            padding: "14px",
            fontSize: "16px",
            fontWeight: "600",
            background: "#14532d",
            color: "#fff",
            border: "none",
            borderRadius: "14px",
            cursor: "pointer",
          }}
        >
          Install App
        </button>

        <button
           onClick={handleMaybeLater}
          style={{
            width: "100%",
            padding: "13px",
            fontSize: "15px",
            fontWeight: "500",
            background: "#f3f4f6",
            color: "#374151",
            border: "none",
            borderRadius: "14px",
            cursor: "pointer",
          }}
        >
          Maybe Later
        </button>
      </div>
    </div>
  </div>
)}
      <AppContext>
        <ModalContext.Provider
          value={{
            
            val2: [isModalOpen, setModalOpen],
            modalData:[modalData,setModalData]
          }}
        >
         
            <Routes>               
                <Route path="/:galleryId" element={<LinkMedia />} /> 
                {/* <Route path="album1/:galleryId" element={<PhotoThumbnail />} />  */}
                <Route path="album/:galleryId" element={<PhotoOnly />} />{/*full photo access */}
                <Route  path="guest/galleries/:galleryId" element={<GuestAccessGallery />} /> {/*Guest photo access */}
            </Routes>
          
        </ModalContext.Provider>
      </AppContext>
    </div>
  );
}

export default App;
